/**
 * How a dashboard or report shows its comparison (AgencyAnalytics' compare
 * "Format": Percentage change or Absolute change). Whoever renders a page
 * provides it from the document's compare setting; widgets read it here.
 */

import { createContext, useContext } from 'react';

import type { ChangeFormat } from './format.ts';
import type { CompareSetting } from './reports-api.ts';

export const ChangeFormatContext = createContext<ChangeFormat>('PERCENT');

export function useChangeFormat(): ChangeFormat {
  return useContext(ChangeFormatContext);
}

export function changeFormatOf(compare: CompareSetting | undefined): ChangeFormat {
  return compare?.format === 'ABSOLUTE' ? 'ABSOLUTE' : 'PERCENT';
}
